/**
 * Swiper Slider for Related Articles
 *
 * @package WPCore
 */

export function initSwiper() {
	const swiperContainer = document.querySelector('.related-articles-swiper');

	if (!swiperContainer) {
		return;
	}

	// eslint-disable-next-line no-undef
	new Swiper('.related-articles-swiper', {
		// Responsive breakpoints
		slidesPerView: 1,
		spaceBetween: 32,

		breakpoints: {
			640: {
				slidesPerView: 2,
				spaceBetween: 32
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 32
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 32
			}
		},

		// Pagination dots
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},

		// Autoplay
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},

		loop: false,

		// Accessibility
		a11y: {
			enabled: true,
			prevSlideMessage: 'Previous article',
			nextSlideMessage: 'Next article',
		}
	});
}
